import L from 'leaflet';
import Popup from '../popup/popup';

const rootPath = '../../../';

export default class Point extends L.Marker {
    constructor(map, data, fnSelectZone) {
        super(data.dataForMap.points[0] || map.getCenter().clone());
        this.options.icon = this.createIcon(data.dataForMap.icon);
        this.map = map;
        this.data = data;
        this.type = data.type;
        this.color = data.dataForMap.color;
        this.icon = data.dataForMap.icon;
        this.name = data.name;
        this.id = data.id;
        this.radius = data.dataForMap.radius;
        this.fnSelectZone = fnSelectZone;

        this.tooltip;
        this.permanentTooltipOpened = false;
        document.addEventListener('map:toggleGeofenceTooltipVisibility', e => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });

        this.addTooltip({ permanent: false });

        this.onOverCircle = null;
        this.on('click', (e) => this.onClick(e));
        this.on('mouseover', (e) => this.onOver(e));
        this.on('mouseout', (e) => this.onOut(e));

        //if (this.name && this.name !== '') {
        //    this.bindTooltip(this.name);
        //}

        this.map.on('zoomend', (e) => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });

        this.map.on('moveend', (e) => {
            try {
                this.toggleTooltipVisibility();
            }
            catch (error) {
                console.error(error);
            }
        });
    }

    getCoords() {
        return this.getLatLngs()[0];
    }

    getLatLngs() {
        let ret = [];
        ret.push(this.getLatLng());
        return ret;
    }

    createIcon(iconPath) {
        let icon = L.icon({
            iconUrl: rootPath + 'img/' + iconPath,
            iconAnchor: [8, 8],
            iconSize: [16, 16],
        });

        icon._createImg = (src, el) => {
            el = el || document.createElement('img');
            el.src = src;
            el.onerror = function (event) {
                this.src = rootPath + 'img/zone_icons/icon2.png';
            };
            return el;
        };
        return icon;
    }

    updateIcon(iconPath) {
        this.setIcon(this.createIcon(iconPath));
    }

    onClick(e) {
        if (this.map.isAllClicksBlocked()) {
            return;
        }
        this.fnSelectZone(this.id)
            .then(data => {
                this.popup = new Popup(this.map, this.name, data.params, e.latlng);
                this.popup.show();
            });
    }

    onOver(e) {
        this.onOverCircle = new L.circle(e.latlng, e.target.radius,
            {
                fill: true,
                fillColor: '#00599F',//e.target.color,
                color: '#00599F',//e.target.color,
                weight: 3,
            });
        this.map.addLayer(this.onOverCircle);
        if (!this.permanentTooltipOpened) {
            this.openTooltip();
        }
    }

    onOut(e) {
        this.map.removeLayer(this.onOverCircle);
        if (!this.permanentTooltipOpened) {
            this.closeTooltip();
        }
    }

    setLatLngs(latLng) {
        if (latLng) this.setLatLng(latLng[0]);
    }

    toggleTooltipVisibility() {
        const options = this.map.options.geofenceTooltip;
        if (
            options.isAlwaysVisible
            && !this.permanentTooltipOpened
            && this.map.getZoom() >= options.minVisibleZoom
            && this.map.getBounds().contains(this.getCoords())
        ) {
            this.permanentTooltipOpened = true;
            this.addTooltip({ permanent: true });
            this.openTooltip(this, this.getCoords());
        }
        else if (
            this.permanentTooltipOpened && !options.isAlwaysVisible
            || this.permanentTooltipOpened && this.map.getZoom() < options.minVisibleZoom
        ) {
            this.permanentTooltipOpened = false;
            this.addTooltip({ permanent: false });
        }
    }

    addTooltip(options) {
        if (this.tooltip) {
            this.unbindTooltip(this.tooltip);
        }
        this.tooltip = L.tooltip({
            permanent: options.permanent,
            interactive: false,
            direction: 'bottom',
            offset: new L.Point(0, 0)
        });
        this.tooltip.setContent(this.name);
        this.tooltip.on('click', (e) => { this._onClick(e) });
        this.bindTooltip(this.tooltip);
    }
}
